import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import store from './store'
import router from './router'
import { Base64 } from 'js-base64'
import '@/vab'
import { download } from '@/utils/request'
import Pagination from '@/components/Pagination'
import SupplierList from '@/components/Gd/SupplierList'
import AISee from '@/components/AISee'
import Log from '@/components/Log'
import UploadFile from '@/components/uploadFile'
import SeeExample from '@/components/SeeExample'
import SelectSku from '@/components/SelectSku'
import VueScroll from '@david-j/vue-j-scroll'
import {
  dictData,
  findMenuById,
  objectDelkey,
  objectSavekey,
} from '@/utils/util'
import {
  divideByHundred,
  multipliedByHundred,
  checkInputNum,
  checkInputEnglishNum,
  checkInputPrice,
  isValueZeroOrExists,
  checkInputCN,
  checkInputEnglish,
  checkInputEnglishB,
  checkInputCNB,
  smalltoBIG,
  checkInputNumber,
} from '@/utils'
import { getDictData } from '@/api/setting/system/dict/data'
import RightToolbar from '@/components/RightToolbar'
import { checkPermi } from '@/utils/permission' // 权限判断函数
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
  treeToTile,
} from '@/utils/ruoyi'
// 字典标签组件
import BaseTable from '@/components/base/BaseTable.vue'
import BaseDialogForm from '@/components/base/BaseDialogForm.vue'
import '@/assets/styles/ruoyi.scss' // ruoyi css
import '@/assets/styles/index.scss' // global css
import md5 from 'js-md5'
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.msgWarning = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'warning' })
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg)
}
Vue.config.productionTip = false
import filters from './utils/filter'
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
import permission from './directive/permission'
import { preventReClick } from './directive/preventReClick' // 自定义指令 v-preventReClick 防止多次点击
// 全局组件挂载
Vue.component('BaseTable', BaseTable)
Vue.component('BaseDialogForm', BaseDialogForm)
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('SupplierList', SupplierList)
Vue.component('UploadFile', UploadFile) // 文件上传组件
Vue.component('SeeExample', SeeExample) // 查看示例
Vue.component('AISee', AISee) // 智能识别
Vue.component('Log', Log) // 智能识别
Vue.component('SelectSku', SelectSku) // 选择单品

// 全局方法挂载
Vue.prototype.getDictData = getDictData
Vue.prototype.findMenuById = findMenuById // 处理树结构数据方法 找到所有节点
Vue.prototype.objectDelkey = objectDelkey // list 列表 post请求需要删除 指定 key   pageNum  pageSize
Vue.prototype.objectSavekey = objectSavekey // list 列表 post只保留   pageNum  pageSize

Vue.prototype.divideByHundred = divideByHundred // 除以100 处理分
Vue.prototype.multipliedByHundred = multipliedByHundred // 乘以100 处理分
Vue.prototype.checkInputNum = checkInputNum // 只允许输入数字
Vue.prototype.checkInputPrice = checkInputPrice // 只允许输入金额
Vue.prototype.checkPermi = checkPermi // 权限判断函数
Vue.prototype.isValueZeroOrExists = isValueZeroOrExists // 判断一个值存在且可以是 0
Vue.prototype.checkInputCN = checkInputCN // 只允许输入中文
Vue.prototype.checkInputCNB = checkInputCNB // 只允许输入中文 + （）() 括号
Vue.prototype.checkInputNumber = checkInputNumber // 只允许输入正数和负数（可带小数点，负号只能在首位）

Vue.prototype.checkInputEnglishNum = checkInputEnglishNum // 只允许输入英文和数字
Vue.prototype.checkInputEnglish = checkInputEnglish // 只允许输入英文
Vue.prototype.checkInputEnglishB = checkInputEnglishB // 只允许输入英文
Vue.prototype.smalltoBIG = smalltoBIG // 金额大写

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.treeToTile = treeToTile
Vue.prototype.dictData = dictData
Vue.prototype.Base64 = Base64
Vue.prototype.pickerOptions = {
  disabledDate(v) {
    return v.getTime() < new Date().getTime() - 86400000
  },
}
Vue.prototype.$bus = new Vue()
Vue.prototype.$md5 = md5

// 点击复制
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(permission)
Vue.use(preventReClick)
Vue.use(VueScroll)

new Vue({
  el: '#app',
  Base64,
  i18n,
  store,
  router,
  render: (h) => h(App),
})

Date.prototype.Format = function (fmt) {
  // 时间转换
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}
